import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { IconifyIcon, InlineIcon } from "@iconify/react";
import { OcBadge } from "../badge";

interface OcAppBarBadgeProps {
  icon: string | IconifyIcon;
  onClick: () => void;
  value: number;
  id?: string;
  badgeId?: string;
  admin?: boolean;
}

export const OcAppBarBadge: React.FC<OcAppBarBadgeProps> = ({
  icon,
  onClick,
  value,
  id,
  badgeId,
  admin,
}) => {
  const theme = useTheme();

  const [iconReady, setIconReady] = React.useState(
    typeof icon !== "string"
  );

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: "pointer",
        padding: "6px",
      }}
    >
      <OcBadge
        badgeContent={value}
        id={badgeId}
        sx={{
          visibility: iconReady ? "visible" : "hidden",
        }}
      >
        <InlineIcon
          icon={icon}
          color={
            admin
              ? theme.palette.primary.main
              : theme.palette.gray60.main
          }
          width="30px"
          height="30px"
          id={id}
          onLoad={() => {
            setIconReady(true);
          }}
        />
      </OcBadge>
    </Box>
  );
};
